module.exports = {
    availableLanguages: {
        english: "ENGLISH",
        portuguese: "PORTUGUÊS",
        german: "DEUTSCH",
        spanish: "ESPAÑOL",
        french: "FRANÇAIS",
        日本語: "日本語",
        arabic: "عربى",
        italian: "ITALIANO",
        dutch: "NEDERLANDS",
        mandarin: "繁體中文",
        hindi:"हिंदी",
        vietnamese:"Tiếng Việt",
        thai:"ไทย",
        filipino:"Filipino"
    },
    languageDropDownDomains: ['app.localclarity.com','app.ormanagement.co','dev.localclarity.com','localhost:3000','app.bizzrep.com','app.localclarity.com.br','stage.localclarity.com'],
    languageCode: {
        english: "en",
        portuguese: "pt",
        german: "de",
        spanish: "es",
        french: "fr",
        日本語: "en",
        arabic: "en",
        italian: "it",
        dutch: "en",
        mandarin: "en",
        hindi:"en",
        vietnamese:"en",
        thai:"en",
        filipino:"en"
    },
}